module.exports = __webpack_public_path__ + "static/img/siwei3.8272fd00.png";